/**
 * Teachers — one page for every scope.
 *
 * National staffing, or one region's roster and shift board.
 *
 * The two bodies are the pages that used to live under `/admin/teachers` and
 * `/r/:regionSlug/teachers`. Neither has changed: at national scope this calls
 * the `/dashboards/admin/…` endpoint the admin page called, and at regional
 * scope the `/dashboards/regional/:slug/…` endpoint the regional page called,
 * so the numbers are the same numbers. What is gone is the second URL tree and
 * the second copy of the chrome around them.
 */
import { DashboardsPage } from '../DashboardsPage';
import { RegionalTeachers } from '../regional/RegionalTeachers';

import AdminTeachers from './AdminTeachers';
import { useDashboardScope } from './dashboard-scope';
import { DashboardScopeHeader } from './DashboardScopeHeader';
import { ScopedDashboardBody } from './ScopedDashboardBody';

export default function TeachersPage() {
  const scope = useDashboardScope();

  return (
    <DashboardsPage
      header={<DashboardScopeHeader title="Teachers" basePath="/admin/teachers" scope={scope} />}
    >
      <ScopedDashboardBody
        scope={scope}
        national={<AdminTeachers />}
        regional={(regionSlug) => <RegionalTeachers regionSlug={regionSlug} />}
      />
    </DashboardsPage>
  );
}
